import { IConfigData } from '@df/catalog/config/config.interfaces';

export namespace NProductPlpTrustpilotReviewsConfig {
    export const ID = 'product-plp-trustpilot-reviews';
    export interface IContent {
        enabled?: boolean;
        templateId?: string;
        businessunitId?: string;
        starColor?: string;
        theme?: string;
    }
    export type TData = IConfigData<IContent>;
}
